<div class="app-layout">
  <app-navbar />

  <main>
    <router-outlet />
  </main>

  <app-footer />
</div>
